<template>
  <div>
    <div class="wrapper__inner--narrow">
      <section class="content content__references">
        <h3>References</h3>
        <div v-for="(reference, index) in content.references" v-bind:key="index" class="references__reference">
          {{ index + 1 }} - <a :href="reference.source" target="_blank">{{ reference.source }}</a> - <b>{{ reference.title }}</b>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SectionReferences',
  props: {
    content: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>
